// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ev53","fullView":"styles_fullView__3gIq9"};